// Copyright (c) Docugami, Inc. All rights reserved.

import { WorkPathsViewer, WorkPathsViewType } from "components/work_path/WorkPathsViewer";
import { ViewSwitcher } from "components/work_path/WorkPathsViews";
import { useState } from "react";
import styled from 'styled-components';
import { PageSection, SectionProps } from "./PageSections";

const WorkSection = styled(PageSection)`
    display: flex;
    flex: 1;
    min-height: 0;
`;

interface WorkSectionProps extends SectionProps {
    title: string;
    coachMark?: JSX.Element;
    automationId: string;
}

export const MyWorkSection = (props: WorkSectionProps): JSX.Element => {
    const [viewType, setViewType] = useState<WorkPathsViewType>(WorkPathsViewType.List);

    return (
        <WorkSection automationId={props.automationId} title={props.title} commands={<ViewSwitcher selectedViewType={viewType} setView={setViewType} />}>
            <WorkPathsViewer
                types={props.types}
                viewType={viewType}
                iconHeight={60}
                coachMark={props.coachMark} />
        </WorkSection>
    );
}